const MARKDOWN_IMAGE_REGEX = /\s*!\[[^\]]*\]\(\s*(https?:\/\/[^\s)]+)[^)]*\)/g

export const extractMarkdownImages = (
  rawText: string
): {
  urls: string[]
  text: string
} => {
  const urls: string[] = []

  const stripped = rawText.replace(MARKDOWN_IMAGE_REGEX, (_match, url: string) => {
    urls.push(url)
    return ''
  })

  const text = stripped.trim() === '' ? '' : stripped

  return { urls, text }
}
